import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import {
  getNumberOverflow,
  isNumberOfUserDisplayed,
} from '../../../ChatComponent/utils';

export const SpHeader = ({
  text,
  numberOfUsers,
}: {
  text: string;
  numberOfUsers?: number;
}) => {
  const numberOfUsersStr = getNumberOverflow(numberOfUsers);
  const numberOfUserDisplayed = isNumberOfUserDisplayed({ numberOfUsers });
  return (
    <View style={styles.container} nativeID="SpHeader">
      <Text style={styles.headerText} numberOfLines={1} lineBreakMode="tail">
        {text}
      </Text>
      {numberOfUserDisplayed ? (
        <Text style={styles.headerText}>({numberOfUsersStr})</Text>
      ) : (
        <></>
      )}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 40,
    paddingVertical: 16,
    backgroundColor: 'white',
    borderBottomWidth: 1,
    borderBottomColor: '#E9EFF2',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginHorizontal: 'auto',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
  },
  headerText: {
    color: '#1A2737',
    fontSize: 14,
    fontWeight: '700',
    lineHeight: 25.2,
    marginHorizontal: 4,
    textAlign: 'center',
  },
});
